import { render } from "./Capabilities.vue?vue&type=template&id=74a7bb9c&scoped=true"
import script from "./Capabilities.vue?vue&type=script&lang=js"
export * from "./Capabilities.vue?vue&type=script&lang=js"

import "./Capabilities.vue?vue&type=style&index=0&id=74a7bb9c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a7bb9c"]])

export default __exports__